/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `DialogType*`'s.
 */
export type DialogType = DialogTypeStandard | DialogTypeWizard;

/**
 * The Dialog standard type.
 */
export type DialogTypeStandard = typeof DIALOG_TYPE_STANDARD;

/**
 * The Dialog wizard type.
 */
export type DialogTypeWizard = typeof DIALOG_TYPE_WIZARD;

/**
 * The Dialog standard constant.
 */
export const DIALOG_TYPE_STANDARD = `standard`;

/**
 * The Dialog wizard constant.
 */
export const DIALOG_TYPE_WIZARD = `wizard`;
